module.exports = __webpack_public_path__ + "img/good6.e6a4a5eb.jpg";